export class SolicitacoesRequestModel {
    constructor() { }

    public ContaId: string;
    public TipoSolicitacao: string;
    public SolicitacaoId: number;
    public Processados: boolean;
    public Cancelados: boolean;
    public SolicitacaoSemPedido: boolean;
    public SolicitacaoSemDetalhamento: boolean;
    public TipoDeposito: number;
}
